import {useMutation} from "@tanstack/react-query";
import {recoverPasswordService} from "../services/account/login.service";

const useRecoverPassword = () => {
  const {mutate, data, isSuccess, isError, error, isPending} = useMutation({
    mutationFn: recoverPasswordService,
    onError: _error => {},
  });

  return {
    requestPassword: mutate,
    data,
    isSuccess,
    isError,
    error,
    isPending,
  };
};

export default useRecoverPassword;
